export const NovelTypeEnum = Object.freeze({
    Novel: 1,
    Tale: 2
});

export default NovelTypeEnum;